import { Container, ContentHeader, Page } from 'components'

import { OrganizationForm } from './components'

const OrganizationsNew = () => {
  return (
    <Page title="Novo Grupo Advisor">
      <Container maxWidth={false}>
        <ContentHeader
          menu="Grupos Advisor"
          title="Novo Grupo Advisor"
          subtitle="Criar Grupo Advisor"
        />
        <OrganizationForm editionPermitted />
      </Container>
    </Page>
  )
}

export default OrganizationsNew
